module.exports = __webpack_public_path__ + "media/college_advice/Watch_tours_widget_040910-b647d608.png";